import { DocumentAIAnalyzingDialog, SdsAnalyzingDialog } from "components/Document";
import { JobExportProgressDialog } from "components/JobExportProgressDialog";
import { DialogType } from "providers/minimizedDialogs";
import { ComponentType } from "react";

const dialogRegistry: Record<DialogType, ComponentType<Record<string, unknown>>> = {
  [DialogType.DocumentAIAnalyzing]: DocumentAIAnalyzingDialog as ComponentType<
    Record<string, unknown>
  >,
  [DialogType.JobExportProgress]: JobExportProgressDialog as ComponentType<Record<string, unknown>>,
  [DialogType.SdsAnalyzing]: SdsAnalyzingDialog as ComponentType<Record<string, unknown>>,
};

export function getDialogComponent(dialogType: DialogType) {
  return dialogRegistry[dialogType];
}
